import { Helmet } from "react-helmet-async";

export default function PolitiqueConfidentialitePage() {
  return (
    <>
      <Helmet><title>Politique de confidentialité - OFALycée</title></Helmet>
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24" data-testid="politique-confidentialite-page">
        <h1 className="font-heading text-3xl md:text-4xl mb-10">Politique de confidentialité</h1>

        <div className="prose max-w-none">
          <p>
            <strong>Date de dernière mise à jour :</strong> 31 mars 2026
          </p>
          <p>
            OFALYCEE, Inc. (ci-après « OFALycée », « nous ») s'engage à protéger la vie privée des
            visiteurs de son site. Cette politique de confidentialité décrit les données que nous collectons,
            comment nous les utilisons et vos droits à leur égard.
          </p>

          <h2>1. Données collectées</h2>

          <h3>a) Données de navigation (automatiques)</h3>
          <p>
            Lors de votre visite, nous collectons automatiquement certaines informations techniques
            via <strong>Google Analytics 4</strong> (GA4) :
          </p>
          <ul>
            <li>Pages consultées et durée de visite</li>
            <li>Source de trafic (moteur de recherche, réseaux sociaux, lien direct)</li>
            <li>Type d'appareil, navigateur et système d'exploitation</li>
            <li>Localisation géographique approximative (pays/ville)</li>
          </ul>
          <p>
            Ces données sont anonymisées et utilisées uniquement à des fins statistiques pour améliorer
            notre contenu éditorial.
          </p>

          <h3>b) Données fournies volontairement</h3>
          <p>
            Si vous vous inscrivez à notre newsletter <strong>La Toile d'OFALycée</strong>,
            nous collectons :
          </p>
          <ul>
            <li>Votre adresse email</li>
            <li>Votre nom (optionnel)</li>
          </ul>

          <h3>c) Données stockées localement</h3>
          <p>
            Les fonctionnalités suivantes utilisent le <strong>stockage local de votre navigateur</strong>
            (localStorage) et ne sont jamais transmises à nos serveurs :
          </p>
          <ul>
            <li>Articles sauvegardés (signets)</li>
            <li>Préférences de lecture (mode clair/sépia/sombre, taille du texte)</li>
          </ul>

          <h2>2. Finalités du traitement</h2>
          <ul>
            <li><strong>Statistiques et amélioration du site</strong> : analyse de la fréquentation et des contenus les plus consultés (GA4)</li>
            <li><strong>Communication</strong> : envoi de la newsletter mensuelle La Toile (uniquement si vous vous êtes inscrit)</li>
            <li><strong>Expérience utilisateur</strong> : sauvegarde de vos préférences de lecture dans votre navigateur</li>
          </ul>

          <h2>3. Cookies et traceurs</h2>
          <p>
            Ce site utilise les cookies suivants :
          </p>
          <ul>
            <li><strong>Google Analytics 4</strong> (_ga, _ga_*) : mesure d'audience anonymisée. Durée : 13 mois maximum.</li>
            <li><strong>Cookies fonctionnels</strong> : authentification pour l'interface d'administration uniquement.</li>
          </ul>
          <p>
            Vous pouvez désactiver les cookies via les paramètres de votre navigateur.
            La désactivation des cookies n'affecte pas la consultation du site.
          </p>

          <h2>4. Partage des données</h2>
          <p>
            Vos données ne sont <strong>jamais vendues</strong> à des tiers. Elles peuvent être partagées avec :
          </p>
          <ul>
            <li><strong>Google LLC</strong> (Google Analytics 4) — mesure d'audience</li>
            <li><strong>HubSpot, Inc.</strong> — gestion et envoi de la newsletter</li>
          </ul>

          <h2>5. Conservation des données</h2>
          <ul>
            <li>Données de navigation (GA4) : 14 mois maximum</li>
            <li>Adresse email (newsletter) : jusqu'à votre désinscription</li>
            <li>Données locales (signets, préférences) : jusqu'à la suppression manuelle dans votre navigateur</li>
          </ul>

          <h2>6. Vos droits</h2>
          <p>
            Conformément à la réglementation applicable, vous disposez des droits suivants :
          </p>
          <ul>
            <li><strong>Accès</strong> : obtenir une copie des données vous concernant</li>
            <li><strong>Rectification</strong> : corriger des données inexactes</li>
            <li><strong>Suppression</strong> : demander l'effacement de vos données</li>
            <li><strong>Opposition</strong> : vous opposer au traitement de vos données</li>
            <li><strong>Désinscription newsletter</strong> : via le lien présent dans chaque email ou en nous contactant</li>
          </ul>
          <p>
            Pour exercer ces droits, contactez-nous à :
            <a href="mailto:contact@ofalycee.org"> contact@ofalycee.org</a>
          </p>

          <h2>7. Sécurité</h2>
          <p>
            Nous mettons en œuvre des mesures techniques et organisationnelles appropriées
            pour protéger vos données contre tout accès non autorisé, modification, divulgation
            ou destruction.
          </p>

          <h2>8. Contact</h2>
          <p>
            Pour toute question relative à cette politique :<br />
            <strong>OFALYCEE, Inc.</strong><br />
            Winchester, Massachusetts, États-Unis<br />
            Email : <a href="mailto:contact@ofalycee.org">contact@ofalycee.org</a>
          </p>
        </div>
      </div>
    </>
  );
}
